module.exports = __webpack_public_path__ + "static/media/approach-completed.887e5dd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/approach-completed.jpg
// module id = 136
// module chunks = 0